/// <reference types="vite/client" />
export const AZL_BASE_URL = import.meta.env.VITE_AZL_BASE_URL || "https://realtors-basket-persons-divide.trycloudflare.com";
export const AZL_CHRONICLE_URL = "https://azl-chronicle.paidingattentionproductions.workers.dev";
export const AZL_ABYSS_URL = "https://azl-universes.paidingattentionproductions.workers.dev/azl/v1/abyss";
export const AZL_SANCTUARY_URL = "https://absolute-zero-lattice-broadcast.onrender.com/";
export const AZL_OMNI_CORE_URL = "https://azl-omni-core.paidingattentionproductions.workers.dev/";
